(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function inputCantidad() {
    return $('[data-sb-form] input[name="quantity"]');
  }

  function fijarCantidad(n) {
    var input = inputCantidad();
    if (!input) return;
    input.value = n;
    ['input', 'change'].forEach(function (tipo) {
      input.dispatchEvent(new Event(tipo, { bubbles: true }));
    });
  }

  function initPacks() {
    var radios = $$('input[name="sb_pack"]');
    if (!radios.length) return;

    function aplicar() {
      var sel = radios.filter(function (r) { return r.checked; })[0] || radios[0];
      radios.forEach(function (r) {
        var tarjeta = r.closest('[data-sb-pack]');
        if (tarjeta) tarjeta.classList.toggle('is-selected', r === sel);
      });
      fijarCantidad(sel.getAttribute('data-cantidad') || '1');
      $$('[data-sb-precio-fijo]').forEach(function (el) { el.textContent = sel.getAttribute('data-precio') || ''; });
      $$('[data-sb-nombre-fijo]').forEach(function (el) { el.textContent = sel.getAttribute('data-corto') || ''; });
    }

    radios.forEach(function (r) { r.addEventListener('change', aplicar); });
    aplicar();
  }

  function sumarDiasHabiles(desde, dias) {
    var f = new Date(desde.getTime());
    var contados = 0;
    while (contados < dias) {
      f.setDate(f.getDate() + 1);
      var dia = f.getDay();
      if (dia !== 0 && dia !== 6) contados++;
    }
    return f;
  }

  function initEntrega() {
    $$('[data-sb-entrega]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      var plantilla = el.getAttribute('data-plantilla');
      if (!plantilla || isNaN(min) || isNaN(max)) return;
      try {
        var fmt = new Intl.DateTimeFormat('es-CO', { weekday: 'long', day: 'numeric', month: 'long' });
        var hoy = new Date();
        var desde = fmt.format(sumarDiasHabiles(hoy, min)).replace(',', '');
        var hasta = fmt.format(sumarDiasHabiles(hoy, max)).replace(',', '');
        el.textContent = plantilla.replace('{desde}', desde).replace('{hasta}', hasta);
      } catch (e) { /* se conserva el texto de respaldo */ }
    });
  }

  function initBarraFija() {
    var barra = $('.sb-fija');
    if (!barra) return;
    document.body.classList.add('sb-tiene-fija');
    var compra = $('#sb-compra');
    var cierre = $('#sb-cierre');
    var pendiente = false;

    function actualizar() {
      pendiente = false;
      var pasado = compra ? compra.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var cierreVisible = false;
      if (cierre) {
        var r = cierre.getBoundingClientRect();
        cierreVisible = r.top < window.innerHeight * 0.85 && r.bottom > 0;
      }
      var mostrar = pasado && !cierreVisible;
      barra.classList.toggle('is-visible', mostrar);
      barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      if ('inert' in barra) barra.inert = !mostrar;
    }

    function pedir() {
      if (pendiente) return;
      pendiente = true;
      window.setTimeout(actualizar, 60);
    }

    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    actualizar();
  }

  function initComprar() {
    document.addEventListener('click', function (e) {
      var boton = e.target.closest ? e.target.closest('[data-sb-comprar]') : null;
      if (!boton) return;
      var cod = $('#rsi_buy_now_button, [data-rsi-cod-button]');
      if (cod && cod !== boton) {
        e.preventDefault();
        cod.click();
        return;
      }
      if (boton.getAttribute('type') === 'button') {
        var form = $('[data-sb-form]');
        if (form) {
          e.preventDefault();
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        }
      }
    });
  }

  function initGaleria() {
    $$('[data-sb-gal]').forEach(function (gal) {
      var pista = $('[data-sb-track]', gal);
      var miniaturas = $$('[data-sb-thumb]', gal);
      if (!pista) return;

      miniaturas.forEach(function (mini, i) {
        mini.addEventListener('click', function () {
          pista.scrollTo({ left: pista.clientWidth * i, behavior: 'smooth' });
        });
      });

      var raf;
      pista.addEventListener('scroll', function () {
        window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function () {
          var i = Math.round(pista.scrollLeft / pista.clientWidth);
          miniaturas.forEach(function (mini, k) {
            mini.classList.toggle('is-active', k === i);
            mini.setAttribute('aria-current', k === i ? 'true' : 'false');
          });
          var activa = miniaturas[i];
          if (activa && activa.parentNode) {
            var tira = activa.parentNode;
            tira.scrollTo({ left: activa.offsetLeft - tira.clientWidth / 2 + activa.clientWidth / 2, behavior: 'smooth' });
          }
        });
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        var videos = $$('video[data-sb-autoplay]', gal);
        var io = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting && en.intersectionRatio >= 0.6) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        }, { threshold: [0, 0.6] });
        videos.forEach(function (v) { io.observe(v); });
      }
    });
  }

  function initTarjeta() {
    document.addEventListener('click', function (e) {
      var boton = e.target.closest ? e.target.closest('[data-sb-tarjeta]') : null;
      if (!boton || boton.disabled) return;
      var form = $('[data-sb-form]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var id = (idInput && idInput.value) || boton.getAttribute('data-variante');
      if (!id) return;
      var cantidad = parseInt((inputCantidad() || {}).value, 10);
      if (isNaN(cantidad) || cantidad < 1) cantidad = 1;

      var botones = $$('[data-sb-tarjeta]');
      var textoEl = boton.querySelector('[data-sb-tarjeta-texto]');
      var original = textoEl ? textoEl.textContent : '';
      var fuente = $('[data-sb-tarjeta][data-procesando]') || boton;
      botones.forEach(function (b) { b.disabled = true; });
      if (textoEl) textoEl.textContent = fuente.getAttribute('data-procesando') || 'Procesando…';

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: cantidad }] })
          });
        })
        .then(function (res) { if (!res.ok) throw new Error('add'); return res.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () {
          botones.forEach(function (b) { b.disabled = false; });
          if (textoEl) textoEl.textContent = original;
          window.alert(fuente.getAttribute('data-error') || 'No se pudo procesar el pago. Inténtalo de nuevo.');
        });
    });
  }

  function init() {
    initPacks();
    initEntrega();
    initBarraFija();
    initComprar();
    initTarjeta();
    initGaleria();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
